import { render, staticRenderFns } from "./WebPhoneRedSantral.vue?vue&type=template&id=25bafe36&scoped=true"
import script from "./WebPhoneRedSantral.vue?vue&type=script&lang=js"
export * from "./WebPhoneRedSantral.vue?vue&type=script&lang=js"
import style0 from "./WebPhoneRedSantral.vue?vue&type=style&index=0&id=25bafe36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bafe36",
  null
  
)

export default component.exports